/**
 * Site-wide constants
 */

export const SITE_NAME = 'Turco Sandalye';
export const SITE_DESCRIPTION = 'Premium luxury chairs and furniture for distinguished spaces';
export const SITE_URL = 'https://turco-sandalye.com';

/**
 * Navigation links
 */
export const NAV_LINKS = [
  { label: 'Ürünler', href: '/products' },
  { label: 'Projeler', href: '/projects' },
  { label: 'Kurumsal', href: '/about' },
  { label: 'İletişim', href: '/contact' },
] as const;

/**
 * Product categories
 */
export const PRODUCT_CATEGORIES = [
  { id: 'chairs', label: 'Sandalyeler', slug: 'chairs' },
  { id: 'tables', label: 'Masalar', slug: 'tables' },
  { id: 'armchairs', label: 'Koltuklular', slug: 'armchairs' },
] as const;

/**
 * Social media links
 */
export const SOCIAL_LINKS = {
  instagram: 'https://instagram.com/turcosandalye',
  whatsapp: 'https://wa.me/905537942161',
  email: 'info@turcosandalye.com',
} as const;

/**
 * Image placeholder for development
 */
export const PLACEHOLDER_IMAGE = 'https://placehold.co/800x600/f5f5f0/2c2a27?text=Turco+Sandalye';

/**
 * API base URL
 */
export const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

/**
 * Breakpoint values (matching Tailwind)
 */
export const BREAKPOINTS = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
} as const;
